<script setup>
import { useI18n } from 'vue-i18n';
import { createRealEstateBrokerInvestmentPresenter } from '../composables/realEstateBrokerInvestmentPresenter';
import RealEstateBrokerInvestmentLoadingList from './RealEstateBrokerInvestmentLoadingList.vue';

defineProps({
  loading: { type: Boolean, default: false },
  rows: { type: Array, default: () => [] },
});

const emit = defineEmits(['open']);
const { t } = useI18n();
const {
  address,
  addressDetail,
  date,
  money,
  temperatureClass,
  temperatureIcon,
  temperatureLabel,
} = createRealEstateBrokerInvestmentPresenter(t);
</script>

<template>
  <div
    class="divide-y divide-lais-border-soft rounded-lais border border-lais-border-soft bg-white shadow-lais-card lg:hidden"
    :aria-busy="loading"
  >
    <RealEstateBrokerInvestmentLoadingList v-if="loading" />
    <p v-else-if="!rows.length" class="p-6 text-center text-lais-text-muted">
      {{ t('REAL_ESTATE_BROKER_INVESTMENT.TABLE.EMPTY') }}
    </p>
    <article
      v-for="row in loading ? [] : rows"
      :key="row.imovel_id"
      class="cursor-pointer space-y-3 p-4 hover:bg-lais-bg-soft/60"
      tabindex="0"
      @click="emit('open', row.imovel_id)"
      @keydown.enter="emit('open', row.imovel_id)"
      @keydown.space.prevent="emit('open', row.imovel_id)"
    >
      <div class="flex items-start justify-between gap-3">
        <span
          class="inline-flex items-center gap-1.5 rounded-full px-2 py-1 text-xs font-semibold"
          :class="temperatureClass(row.temperatura_calculada)"
        >
          <span
            class="size-3.5"
            :class="[temperatureIcon(row.temperatura_calculada)]"
          />
          {{ temperatureLabel(row.temperatura_calculada) }}
        </span>
        <p class="font-bold text-lais-text">{{ money(row.valor_anunciado) }}</p>
      </div>
      <div class="flex items-center gap-3">
        <img
          v-if="row.imagem"
          :src="row.imagem"
          :alt="t('REAL_ESTATE_BROKER_INVESTMENT.TABLE.IMAGE_ALT')"
          class="size-10 rounded-full object-cover"
        />
        <span
          v-else
          class="i-lucide-image size-10 rounded-full bg-lais-bg-soft p-2 text-lais-text-muted"
        />
        <div class="min-w-0">
          <p class="truncate font-semibold text-lais-text">
            {{ address(row) }}
          </p>
          <p
            v-if="addressDetail(row)"
            class="truncate text-xs text-lais-text-muted"
          >
            {{ addressDetail(row) }}
          </p>
        </div>
      </div>
      <p class="text-xs text-lais-text-muted">
        {{
          t('REAL_ESTATE_BROKER_INVESTMENT.TABLE.UPDATED_VALUE', {
            date: date(row.atualizado_em),
          })
        }}
      </p>
    </article>
  </div>
</template>
